module.exports = __webpack_public_path__ + "static/media/Logo.d09e3d5a.png";